import { render, staticRenderFns } from "./BreakoutRoomsTab.vue?vue&type=template&id=1cc70c76&scoped=true"
import script from "./BreakoutRoomsTab.vue?vue&type=script&lang=js"
export * from "./BreakoutRoomsTab.vue?vue&type=script&lang=js"
import style0 from "./BreakoutRoomsTab.vue?vue&type=style&index=0&id=1cc70c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc70c76",
  null
  
)

export default component.exports